<arb-viewer-pdf-page class="page" *ngFor="let page of pages$ | async" [pdfPageProxy]="page">
  <ng-container
    [ngTemplateOutlet]="pageHeaderTemplate">
  </ng-container>
</arb-viewer-pdf-page>
